module.exports = __webpack_public_path__ + "img/ic_qrcode_ins.e0af082.webp";